<template>
  <img
    :src="src"
    :class="[size, {
      'guest': guest
    }]"
  />
</template>

<script>
export default {
  name: 'ProaAvatar',
  props: {
    src: String,
    size: {
      type: String,
      default: 'md'
    },
    guest: Boolean
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

img {
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid $light-border-color;

  &.md {
    width: 80px;
    height: 80px;
  }

  &.sm {
    width: 40px;
    height: 40px;
  }

  &.xs {
    width: 26px;
    height: 26px;
  }

  &.guest {
    border: 1px solid $guest-color;

    &.md {
      border: 2px solid $guest-color;
    }
  }
}
</style>
